<template>
  <button
    class="btn"
    :class="{
      'disabled': disabled || submitting
    }"
    :disabled="disabled || submitting"
    type="button"
    @click="submit($event)"
    @keydown.space="submit($event)"
  >
    <ButtonLoadingSpinner v-if="submitting"></ButtonLoadingSpinner>
    <slot>
      {{ buttonText }}
    </slot>
  </button>
</template>

<script>

export default {
props: {
  disabled: {
    type: Boolean
  },
  submitting: {
    type: Boolean
  },
  buttonText: {
    type: String,
    default: ''
  }
},
emits: ['clicked'],
methods: {
  submit() {
    this.$emit('clicked')
  }
}
//props: ['disabled', 'submitting', 'type']
}
</script>

<style lang="scss" scoped>
</style>
